import { EventMetadata } from '~analytics/EventMetadata';
import { EventTypes } from '~analytics/types';

export const questionTypeChangeInitiatedEventMetadata: EventMetadata = {
  name: EventTypes.QuestionTypeChangeInitiated,
  description:
    'A teacher opened the question type picker in the quiz editor. Pair with question_type_change_confirmed and question_type_change_cancelled to compute the completion ratio.',
  category: 'Quiz Editor',
  platform: 'client',
  status: 'active',
  properties: {
    from_type: {
      type: 'enum',
      values: ['multiple_choice', 'short_answer', 'true_false'],
      description: 'The question type before the picker was opened.',
      required: true,
    },
    quiz_id: {
      type: 'number',
      description: 'ID of the quiz being edited.',
      required: true,
    },
    question_position: {
      type: 'number',
      description: 'Order position of the question within the quiz (1-based).',
      required: true,
    },
  },
};

export const questionTypeChangeConfirmedEventMetadata: EventMetadata = {
  name: EventTypes.QuestionTypeChangeConfirmed,
  description:
    'A teacher confirmed a question type switch in the quiz editor (either directly or via the confirmation dialog).',
  category: 'Quiz Editor',
  platform: 'client',
  status: 'active',
  properties: {
    from_type: {
      type: 'enum',
      values: ['multiple_choice', 'short_answer', 'true_false'],
      description: 'The question type before the switch.',
      required: true,
    },
    to_type: {
      type: 'enum',
      values: ['multiple_choice', 'short_answer', 'true_false'],
      description: 'The question type after the switch.',
      required: true,
    },
    quiz_id: {
      type: 'number',
      description: 'ID of the quiz being edited.',
      required: true,
    },
    question_position: {
      type: 'number',
      description: 'Order position of the question within the quiz (1-based).',
      required: true,
    },
  },
};

export const questionTypeChangeCancelledEventMetadata: EventMetadata = {
  name: EventTypes.QuestionTypeChangeCancelled,
  description:
    'A teacher dismissed the question type change confirmation dialog without switching.',
  category: 'Quiz Editor',
  platform: 'client',
  status: 'active',
  properties: {
    from_type: {
      type: 'enum',
      values: ['multiple_choice', 'short_answer', 'true_false'],
      description: 'The original question type (unchanged after cancel).',
      required: true,
    },
    attempted_to_type: {
      type: 'enum',
      values: ['multiple_choice', 'short_answer', 'true_false'],
      description: 'The question type the teacher tried to switch to.',
      required: true,
    },
    quiz_id: {
      type: 'number',
      description: 'ID of the quiz being edited.',
      required: true,
    },
  },
};
